<template>
  <div style="margin-bottom: 10px">
    <el-card class="box-card" v-if="data">
      <el-form ref="data" :model="data" label-width="100px" size="mini">
        <el-form-item label="支付项：" prop="payPoint">
          <pay-point-selector
            placeholder="请选择"
            @ready="onPayPointSelectorReady"
            @change="onPayPointSelectorChange"
            ref="payPointSelector"
          >
          </pay-point-selector>
        </el-form-item>
        <el-form-item label="标题：">
          <el-card style="width: 500px">
            <base-desc
              @updated="updatedDataTitle"
              v-model="data.title"
            ></base-desc>
          </el-card>
        </el-form-item>
        <el-form-item label="描述：">
          <el-card style="width: 500px">
            <base-desc
              @updated="updatedDataContext"
              v-model="data.context"
            ></base-desc>
          </el-card>
        </el-form-item>

        <el-form-item label="天数：">
          <el-card>
            <el-button
              size="medium"
              type="primary"
              plain
              icon="el-icon-plus"
              style="margin-bottom: 10px"
              @click="addDay()"
              >新增天数</el-button
            >
            <el-card
              class="box-card"
              style="margin-bottom: 10px"
              v-for="(day, index) of data.days"
              :key="index"
            >
              <el-form-item label="第几天：" label-width="70px">
                <el-input style="width: 80px" v-model="day.day"></el-input>

                <el-button
                  @click="removeDay(index)"
                  style="float: right"
                  icon="el-icon-delete"
                  type="danger"
                  circle
                >
                </el-button>
              </el-form-item>
              <el-form-item label="任务：" label-width="70px">
                <el-card class="box-card">
                  <el-button
                    size="medium"
                    type="primary"
                    plain
                    icon="el-icon-plus"
                    style="margin-bottom: 10px"
                    @click="openTaskDialog(true, null, day.day, 0)"
                    >新增任务</el-button
                  >
                  <el-table
                    :data="day.tasks"
                    border
                    size="small"
                    style="margin-top: 10px"
                  >
                    <el-table-column
                      prop="id"
                      label="ID"
                      align="center"
                      width="80"
                      fixed
                      show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                      prop="goalType"
                      label="目标类型"
                      align="center"
                      width="80"
                      fixed
                    >
                      <template slot="header">
                        <span>目标类型</span>
                        <div>
                          <el-tooltip effect="dark" placement="top">
                            <div slot="content">
                              <MicrofilmComponent
                                :keyword="'dayTaskOfAnniversaryMission-goalType'"
                              ></MicrofilmComponent>
                            </div>
                            <span
                              ><i
                                class="el-icon-question"
                                style="font-size: 1.2em"
                              ></i
                            ></span>
                          </el-tooltip>
                        </div>
                      </template>
                      <template slot-scope="scope">
                        {{ scope.row.goalType }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="typeDetermination"
                      label="类型判断"
                      align="center"
                      width="80"
                      fixed
                    >
                      <template slot="header">
                        <span>类型判断</span>
                        <div>
                          <el-tooltip effect="dark" placement="top">
                            <div slot="content">
                              <MicrofilmComponent
                                :keyword="'dayTaskOfAnniversaryMission-typeDetermination'"
                              ></MicrofilmComponent>
                            </div>
                            <span
                              ><i
                                class="el-icon-question"
                                style="font-size: 1.2em"
                              ></i
                            ></span>
                          </el-tooltip>
                        </div>
                      </template>
                      <template slot-scope="scope">
                        {{ scope.row.typeDetermination }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="schedule1"
                      label="任务条件1"
                      align="center"
                      width="80"
                      show-overflow-tooltip
                      fixed
                    >
                      <template slot="header">
                        <span>任务条件1</span>
                        <div>
                          <el-tooltip effect="dark" placement="top">
                            <div slot="content">
                              <MicrofilmComponent
                                :keyword="'dayTaskOfAnniversaryMission-schedule1'"
                              ></MicrofilmComponent>
                            </div>
                            <span
                              ><i
                                class="el-icon-question"
                                style="font-size: 1.2em"
                              ></i
                            ></span>
                          </el-tooltip>
                        </div>
                      </template>
                      <template slot-scope="scope">
                        {{ scope.row.schedule1 }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="schedule2"
                      label="任务条件2"
                      align="center"
                      width="80"
                      show-overflow-tooltip
                      fixed
                    >
                      <template slot="header">
                        <span>任务条件2</span>
                        <div>
                          <el-tooltip effect="dark" placement="top">
                            <div slot="content">
                              <MicrofilmComponent
                                :keyword="'dayTaskOfAnniversaryMission-schedule2'"
                              ></MicrofilmComponent>
                            </div>
                            <span
                              ><i
                                class="el-icon-question"
                                style="font-size: 1.2em"
                              ></i
                            ></span>
                          </el-tooltip>
                        </div>
                      </template>
                      <template slot-scope="scope">
                        {{ scope.row.schedule2 }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="jumpType"
                      label="跳转类型"
                      align="center"
                      width="80"
                      fixed
                    >
                      <template slot="header">
                        <span>跳转类型</span>
                        <div>
                          <el-tooltip effect="dark" placement="top">
                            <div slot="content">
                              <MicrofilmComponent
                                :keyword="'dayTaskOfAnniversaryMission-jumpType'"
                              ></MicrofilmComponent>
                            </div>
                            <span
                              ><i
                                class="el-icon-question"
                                style="font-size: 1.2em"
                              ></i
                            ></span>
                          </el-tooltip>
                        </div>
                      </template>
                      <template slot-scope="scope">
                        {{ scope.row.jumpType }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="jumpPath"
                      label="跳转路径"
                      align="center"
                      width="80"
                      fixed
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        {{ scope.row.jumpPath }}
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="desc"
                      label="任务描述"
                      align="center"
                      width="200"
                    >
                      <template slot-scope="scope">
                        <el-popover placement="top" width="400" trigger="hover">
                          <el-descriptions :column="1" border>
                            <el-descriptions-item
                              :labelStyle="{ width: '55px' }"
                              v-for="(value, language, index) in scope.row.desc"
                              :key="index"
                              :label="language"
                              >{{ value }}</el-descriptions-item
                            >
                          </el-descriptions>
                          <div slot="reference" style="white-space: nowrap">
                            <div
                              v-for="(value, language, index) in scope.row.desc"
                              :key="index"
                              style="text-align: left"
                            >
                              {{ language }}：{{ value }}
                            </div>
                          </div>
                        </el-popover>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="rewards"
                      label="奖励"
                      align="center"
                      width="396"
                    >
                      <template slot-scope="scope">
                        <ShowItems :items="scope.row.rewards" />
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="payRewards"
                      label="付费奖励"
                      align="center"
                      width="396"
                    >
                      <template slot-scope="scope">
                        <ShowItems :items="scope.row.payRewards" />
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop=""
                      label="操作"
                      align="center"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <span
                          class="link-button"
                          style="color: red"
                          @click="removeTask(day.day, scope.$index)"
                          >删除</span
                        >
                        <span
                          class="link-button"
                          @click="
                            openTaskDialog(
                              false,
                              scope.row,
                              day.day,
                              scope.$index
                            )
                          "
                          >编辑</span
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-card>
              </el-form-item>
            </el-card>
          </el-card>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import ShowItems from "./components/ShowItems";
import MicrofilmComponent from "@/components/MicrofilmComponent";
import BaseDesc from "./biz-components/BaseDesc";
import PayPointSelector from "@/components/PayPointSelector";

export default {
  data() {
    return {
      data: null,
      payPointMap: {},
    };
  },
  components: {
    ShowItems,
    MicrofilmComponent,
    BaseDesc,
    PayPointSelector,
  },
  async created() {
    await this.loadConfig();
    if (this.parameter) {
      this.data = JSON.parse(this.parameter);
    } else {
      this.data = {
        days: [],
      };
    }
  },

  props: {
    parameter: "",
  },

  watch: {
    data: {
      async handler() {
        await this.updatedParam();
      },
      deep: true,
    },
  },

  computed: {},

  methods: {
    async addDay() {
      this.data.days.push({ day: this.data.days.length + 1 });
    },
    async removeDay(index) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除第${this.data.days[index].day}天？`);
        this.data.days.splice(index, 1);
      } catch (error) {}
    },
    async openTaskDialog(isCreated, entry, day, index) {
      let d;
      for (let item of this.data.days) {
        if (item.day == day) {
          d = item;
          break;
        }
      }

      this.$dialogutil.open("EditDayTaskDialogOfAnniversaryMission", {
        closedCallback: async (param) => {
          if (param != null) {
            if (isCreated) {
              d.tasks.push(param);
            } else {
              this.$set(d.tasks, index, param);
            }
          }
        },
        data: { isCreated, entry },
      });
    },

    async removeTask(day, index) {
      try {
        for (let d of this.data.days) {
          if (d.day == day) {
            // 弹确认框
            await this.$confirm(
              `确认删除第${d.day}天，ID为${d.tasks[index].id}的任务？`
            );
            d.tasks.splice(index, 1);
            break;
          }
        }
      } catch (error) {}
    },

    async updatedDataTitle(param) {
      this.data.title = param;
    },
    async updatedDataContext(param) {
      this.data.context = param;
    },

    async loadConfig() {},

    async updatedParam() {
      for (let day of this.data.days) {
        day.day = parseInt(day.day);
      }
      this.$emit("updated", JSON.stringify(this.data), async () => {
        // 排序
        this.data.days.sort((x, y) => {
          return x.day - y.day;
        });
      });
    },

    async onPayPointSelectorReady() {
      this.$refs.payPointSelector.payPoint = this.data.payPoint;
    },

    async onPayPointSelectorChange(newValue, oldValue) {
      this.data.payPoint = newValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 0px 0;
}

.el-table .cell.el-tooltip {
  white-space: normal;
}
</style>